import { getAuthModule } from 'auth/store/authModule';
import { getVehicleModule } from 'chariot/store/vehicleModule';
import { getLayoutModule } from 'core-lib/reduxStore/layout/layoutModule';
import { getMiscModule } from 'core-lib/reduxStore/misc/miscModule';
import { getProfileModule } from 'core-lib/reduxStore/profile/profileModule';
import { getSettingModule } from 'core-lib/reduxStore/setting/settingModule';
import { getPaymentModule } from 'payments-ui-v2/store/paymentModule';
import { getParkPlusStoreV2Module } from 'src/modules/parkplusStoreV2/store/parkplusStoreV2Module';

export enum Modules {
  Auth,
  Misc,
  Layout,
  Profile,
  Setting,
  PaymentNew,
  VehicleNew,
  ParkplusStoreV2,
}

const reduxModuleMap = {
  [Modules.Layout]: getLayoutModule(),
  [Modules.Misc]: getMiscModule(),
  [Modules.Setting]: getSettingModule(),
  [Modules.Profile]: getProfileModule(),
  [Modules.Auth]: getAuthModule(),
  [Modules.PaymentNew]: getPaymentModule(),
  [Modules.VehicleNew]: getVehicleModule(),
  [Modules.ParkplusStoreV2]: getParkPlusStoreV2Module(),
};

export const DEFAULT_REDUX_MODULES = [
  Modules.Auth,
  Modules.Layout,
  Modules.Misc,
  Modules.Setting,
  Modules.Profile,
];

export const loadReduxModules = (modules: any[]) => {
  const reduxModules = [];
  modules.forEach((m) => {
    reduxModules.push(reduxModuleMap[m]);
  });
  return reduxModules;
};
